import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';

export default function ResetContrasenya() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [valid, setValid] = useState(null); // null=carregant, true, false
  const [nova, setNova] = useState('');
  const [confirma, setConfirma] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState('');

  useEffect(() => {
    fetch(`/api/auth/validate-reset/${token}`)
      .then(r => r.json())
      .then(d => setValid(d.valid === true))
      .catch(() => setValid(false));
  }, [token]);

  async function handleReset(e) {
    e.preventDefault();
    setError('');
    if (nova.length < 6) {
      setError('La contrasenya ha de tenir mínim 6 caràcters.');
      return;
    }
    if (nova !== confirma) {
      setError('Les contrasenyes no coincideixen');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: nova }),
      });
      const data = await res.json();
      if (res.ok && data.ok) {
        setToast('Contrasenya actualitzada correctament');
        setTimeout(() => navigate('/login', { replace: true }), 2000);
      } else {
        setError(data.error || 'Error en guardar la contrasenya');
      }
    } catch {
      setError('Error de connexió');
    } finally {
      setLoading(false);
    }
  }

  if (valid === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500 text-sm">Validant l'enllaç...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <img
            src="/logomontcadayreixac.png"
            alt="Ajuntament de Montcada i Reixac"
            className="h-16 object-contain"
          />
        </div>

        {!valid ? (
          <div className="text-center space-y-4">
            <p className="text-gray-700">L'enllaç ha caducat o no és vàlid.</p>
            <Link to="/login" className="text-accent underline text-sm">
              Torna a sol·licitar el restabliment
            </Link>
          </div>
        ) : (
          <form onSubmit={handleReset} className="space-y-4">
            <h1 className="text-lg font-medium text-gray-800 text-center mb-2">
              Estableix una nova contrasenya
            </h1>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Nova contrasenya</label>
              <input
                type="password"
                value={nova}
                onChange={e => setNova(e.target.value)}
                className="w-full border border-accent rounded-lg px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-accent"
                minLength={6}
                required
                autoFocus
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">Confirma la contrasenya</label>
              <input
                type="password"
                value={confirma}
                onChange={e => setConfirma(e.target.value)}
                className="w-full border border-accent rounded-lg px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-accent"
                required
              />
            </div>

            {error && <p className="text-red-600 text-sm">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-dark text-white rounded-lg py-3 text-base font-medium min-h-[44px] disabled:opacity-60"
            >
              {loading ? 'Guardant...' : 'Guardar'}
            </button>
          </form>
        )}

        {toast && (
          <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-dark text-white px-6 py-3 rounded-lg shadow-lg text-sm">
            {toast}
          </div>
        )}
      </div>
    </div>
  );
}
